/* eslint-disable prettier/prettier */
/**
 * SADEMS Demo - Mock API Setup
 * Intercepta todas las llamadas axios y devuelve datos mock
 */
import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import { API_URL } from "config/api";
import * as data from "./mockData";

// Crear mock adapter — onNoMatch: "passthrough" deja pasar las que no matchean
const mock = new MockAdapter(axios, { delayResponse: 300, onNoMatch: "passthrough" });

console.log("[SADEMS Demo] Modo demo activado — Datos mock habilitados");

// ============ MAIN DASHBOARD ============
mock.onGet(`${API_URL}/count`).reply(200, data.mainDashboardStats.count);
mock.onGet(`${API_URL}/ingresos`).reply(200, data.mainDashboardStats.ingresos);
mock.onGet(`${API_URL}/sucursales`).reply(200, data.mainDashboardStats.sucursales);
mock.onGet(`${API_URL}/activos`).reply(200, data.mainDashboardStats.activos);
mock.onGet(`${API_URL}/ingresos-por-empresa`).reply(200, data.mainDashboardStats.ingresosPorEmpresa);
mock.onGet(`${API_URL}/acciones-chart`).reply(200, data.mainDashboardStats.acciones);
mock.onGet(`${API_URL}/ingresos-consolidados-chart`).reply(200, data.mainDashboardStats.ingresosConsolidados);

// ============ AUTH ============
mock.onPost(`${API_URL}/login`).reply((config) => {
    const body = JSON.parse(config.data);
    if (body.email === "demo@sadems.com" && body.password === "demo123") {
        return [200, { message: "Login successful", token: data.MOCK_TOKEN, user: data.MOCK_USER }];
    }
    return [401, { message: "Credenciales inválidas" }];
});
mock.onPost(`${API_URL}/register`).reply(200, { message: "Registro exitoso", user: data.MOCK_USER });
mock.onPost(`${API_URL}/logout`).reply(200, { message: "Logout exitoso" });
mock.onGet(`${API_URL}/user`).reply(200, data.MOCK_USER);

// ============ EMPRESAS ============
mock.onGet(new RegExp(`${API_URL}/empresas.*`)).reply(200, data.empresas);
mock.onPost(`${API_URL}/empresas`).reply(201, { message: "Empresa registrada", id: 6 });
mock.onGet(new RegExp(`${API_URL}/empresa/[^/]+`)).reply(200, data.empresas[0]);
mock.onPut(new RegExp(`${API_URL}/empresa/[^/]+`)).reply(200, { message: "Empresa actualizada" });
mock.onDelete(new RegExp(`${API_URL}/empresa/[^/]+`)).reply(200, { message: "Empresa eliminada" });
mock.onGet(new RegExp(`${API_URL}/empresa/carpeta/[^/]+`)).reply(200, []);

// ============ USUARIOS ============
mock.onGet(new RegExp(`${API_URL}/usuarios.*`)).reply(200, data.usuarios);
mock.onPost(`${API_URL}/usuarios`).reply(201, { message: "Usuario creado" });
mock.onGet(new RegExp(`${API_URL}/usuario/[^/]+`)).reply(200, data.usuarios[0]);
mock.onPut(new RegExp(`${API_URL}/usuario/[^/]+`)).reply(200, { message: "Usuario actualizado" });
mock.onDelete(new RegExp(`${API_URL}/usuario/[^/]+`)).reply(200, { message: "Usuario eliminado" });
mock.onGet(`${API_URL}/usuario/find/rol`).reply(200, data.usuarios);

// ============ ROLES ============
mock.onGet(new RegExp(`${API_URL}/roles.*`)).reply(200, data.roles);
mock.onPost(`${API_URL}/roles`).reply(201, { message: "Rol creado" });
mock.onGet(new RegExp(`${API_URL}/rol/\\d+.*`)).reply(200, data.roles[0]);
mock.onPut(new RegExp(`${API_URL}/rol/\\d+.*`)).reply(200, { message: "Rol actualizado" });
mock.onDelete(new RegExp(`${API_URL}/rol/\\d+`)).reply(200, { message: "Rol eliminado" });

// ============ SUCURSALES ============
mock.onGet(new RegExp(`${API_URL}/sucursales.*`)).reply(200, data.sucursales);
mock.onPost(`${API_URL}/sucursales`).reply(201, { message: "Sucursal creada" });
mock.onGet(new RegExp(`${API_URL}/sucursal/\\d+.*`)).reply(200, data.sucursales[0]);
mock.onPut(new RegExp(`${API_URL}/sucursal/\\d+.*`)).reply(200, { message: "Sucursal actualizada" });

// ============ CATEGORIAS ============
mock.onGet(new RegExp(`${API_URL}/categorias.*`)).reply(200, data.categorias);
mock.onPost(`${API_URL}/categorias`).reply(201, { message: "Categoría creada" });
mock.onGet(new RegExp(`${API_URL}/categoria/\\d+.*`)).reply(200, data.categorias[0]);
mock.onPut(new RegExp(`${API_URL}/categoria/\\d+.*`)).reply(200, { message: "Categoría actualizada" });
mock.onDelete(new RegExp(`${API_URL}/categoria/\\d+`)).reply(200, { message: "Categoría eliminada" });

// ============ ALMACENES ============
mock.onGet(new RegExp(`${API_URL}/almacenes.*`)).reply(200, data.almacenes);
mock.onPost(`${API_URL}/almacenes`).reply(201, { message: "Almacén creado" });
mock.onGet(new RegExp(`${API_URL}/almacen/\\d+.*`)).reply(200, data.almacenes[0]);
mock.onPut(new RegExp(`${API_URL}/almacen/\\d+.*`)).reply(200, { message: "Almacén actualizado" });
mock.onDelete(new RegExp(`${API_URL}/almacen/\\d+`)).reply(200, { message: "Almacén eliminado" });

// ============ MOVIMIENTOS ============
mock.onGet(new RegExp(`${API_URL}/movimientos.*`)).reply(200, data.movimientos);
mock.onPost(`${API_URL}/movimientos`).reply(201, { message: "Movimiento registrado" });
mock.onGet(new RegExp(`${API_URL}/movimiento/\\d+.*`)).reply(200, data.movimientos[0]);

// ============ INVENTARIO ============
mock.onGet(new RegExp(`${API_URL}/inventario\\??.*`)).reply(200, data.productos);
mock.onGet(new RegExp(`${API_URL}/inventario/\\d+.*`)).reply(200, data.productos[0]);
mock.onGet(`${API_URL}/inventario/estadisticas`).reply(200, data.inventarioEstadisticas);
mock.onGet(`${API_URL}/inventario/ajustes`).reply(200, data.inventarioAjustes);
mock.onPost(`${API_URL}/inventario/ajustes`).reply(201, { message: "Ajuste registrado" });
mock.onGet(`${API_URL}/inventario/movimientos-chart`).reply(200, { labels: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"], datasets: { label: "Movimientos", data: [5, 8, 4, 6, 7, 2, 3] } });
mock.onGet(`${API_URL}/inventario/valor-por-categoria`).reply(200, { labels: ["Electrónica", "Alimentos", "Medicamentos"], datasets: { label: "Valor", data: [45000, 32000, 12000] } });
mock.onGet(`${API_URL}/inventario/stock-bajo`).reply(200, data.inventarioStockBajo);
mock.onGet(`${API_URL}/inventario/valor-por-almacen`).reply(200, data.inventarioValorPorAlmacen);
mock.onGet(`${API_URL}/inventario/transferencias`).reply(200, data.inventarioTransferencias);
mock.onPost(`${API_URL}/inventario/transferencias`).reply(201, { message: "Transferencia registrada" });
mock.onGet(new RegExp(`${API_URL}/inventario/transferencias/\\d+`)).reply(200, data.inventarioTransferencias[0]);

// ============ PRODUCTOS ============
mock.onGet(new RegExp(`${API_URL}/productos.*`)).reply(200, data.productos);
mock.onPost(`${API_URL}/productos`).reply(201, { message: "Producto creado" });
mock.onGet(new RegExp(`${API_URL}/productos/\\d+/detalles`)).reply(200, data.productos[0]);
mock.onGet(new RegExp(`${API_URL}/productos/\\d+`)).reply(200, data.productos[0]);
mock.onPut(new RegExp(`${API_URL}/productos/\\d+`)).reply(200, { message: "Producto actualizado" });
mock.onDelete(new RegExp(`${API_URL}/productos/\\d+`)).reply(200, { message: "Producto eliminado" });
mock.onPost(new RegExp(`${API_URL}/productos/\\d+/ajustar-stock`)).reply(200, { message: "Stock ajustado" });

// ============ CLIENTES ============
mock.onGet(new RegExp(`${API_URL}/clientes.*`)).reply(200, data.clientes);
mock.onPost(`${API_URL}/clientes`).reply(201, { message: "Cliente creado" });
mock.onGet(new RegExp(`${API_URL}/clientes/\\d+.*`)).reply(200, data.clientes[0]);
mock.onPut(new RegExp(`${API_URL}/clientes/\\d+`)).reply(200, { message: "Cliente actualizado" });
mock.onDelete(new RegExp(`${API_URL}/clientes/\\d+`)).reply(200, { message: "Cliente eliminado" });

// ============ VENTAS ============
mock.onGet(new RegExp(`${API_URL}/ventas.*`)).reply(200, data.ventas);
mock.onPost(`${API_URL}/ventas`).reply(201, { message: "Venta registrada" });
mock.onGet(new RegExp(`${API_URL}/venta/\\d+.*`)).reply(200, data.ventas[0]);
mock.onGet(`${API_URL}/ventas/reporte`).reply(200, data.reportesVentasOperativo);
mock.onGet(`${API_URL}/ventas/productos-populares`).reply(200, data.reportesVentasOperativo.top_productos);

// ============ METODOS DE PAGO ============
mock.onGet(new RegExp(`${API_URL}/metodos-pago.*`)).reply(200, data.metodosPago);

// ============ PROVEEDORES ============
mock.onGet(new RegExp(`${API_URL}/proveedores.*`)).reply(200, data.proveedores);
mock.onPost(`${API_URL}/proveedores`).reply(201, { message: "Proveedor creado" });
mock.onGet(new RegExp(`${API_URL}/proveedor/\\d+.*`)).reply(200, data.proveedores[0]);
mock.onPut(new RegExp(`${API_URL}/proveedor/\\d+`)).reply(200, { message: "Proveedor actualizado" });
mock.onDelete(new RegExp(`${API_URL}/proveedor/\\d+`)).reply(200, { message: "Proveedor eliminado" });

// ============ COMPRAS ============
mock.onGet(new RegExp(`${API_URL}/compras.*`)).reply(200, data.compras);
mock.onPost(`${API_URL}/compras`).reply(201, { message: "Compra registrada" });
mock.onGet(new RegExp(`${API_URL}/compra/\\d+.*`)).reply(200, data.compras[0]);
mock.onGet(`${API_URL}/compras/pendientes`).reply(200, data.compras.filter((c) => c.estado === "pendiente"));

// ============ COTIZACIONES ============
mock.onGet(new RegExp(`${API_URL}/cotizaciones.*`)).reply(200, data.cotizaciones);
mock.onPost(`${API_URL}/cotizaciones`).reply(201, { message: "Cotización creada" });
mock.onGet(new RegExp(`${API_URL}/cotizacion/\\d+.*`)).reply(200, data.cotizaciones[0]);

// ============ RECEPCIONES ============
mock.onGet(new RegExp(`${API_URL}/recepciones.*`)).reply(200, data.recepciones);
mock.onPost(`${API_URL}/recepciones`).reply(201, { message: "Recepción registrada" });
mock.onGet(new RegExp(`${API_URL}/recepcion/\\d+`)).reply(200, data.recepciones[0]);

// ============ AUDITORÍA ============
mock.onGet(`${API_URL}/audit-logs`).reply(200, data.auditLogs);
mock.onGet(`${API_URL}/audit-logs/export`).reply(200, { url: "#", message: "Exportación demo no disponible" });
mock.onPost(`${API_URL}/audit-logs/cleanup`).reply(200, { message: "Limpieza completada (demo)" });

// ============ CONTABILIDAD ============
mock.onGet(`${API_URL}/contabilidad/dashboard`).reply(200, data.contabilidadDashboard);
mock.onGet(`${API_URL}/contabilidad/cuentas`).reply(200, data.contabilidadCuentas);
mock.onPost(`${API_URL}/contabilidad/cuentas`).reply(201, { message: "Cuenta creada" });
mock.onGet(new RegExp(`${API_URL}/contabilidad/cuentas/\\d+`)).reply(200, data.contabilidadCuentas[0]);
mock.onPut(new RegExp(`${API_URL}/contabilidad/cuentas/\\d+`)).reply(200, { message: "Cuenta actualizada" });
mock.onGet(`${API_URL}/contabilidad/asientos`).reply(200, data.contabilidadAsientos);
mock.onPost(`${API_URL}/contabilidad/asientos`).reply(201, { message: "Asiento creado" });
mock.onGet(new RegExp(`${API_URL}/contabilidad/asientos/\\d+`)).reply(200, data.contabilidadAsientos[0]);
mock.onGet(new RegExp(`${API_URL}/contabilidad/libro-mayor.*`)).reply(200, data.contabilidadLibroMayor);
mock.onGet(new RegExp(`${API_URL}/contabilidad/balance-general.*`)).reply(200, data.contabilidadBalanceGeneral);
mock.onGet(new RegExp(`${API_URL}/contabilidad/estado-resultados.*`)).reply(200, data.contabilidadEstadoResultados);
mock.onGet(new RegExp(`${API_URL}/contabilidad/flujo-caja.*`)).reply(200, data.contabilidadFlujoCaja);
mock.onGet(`${API_URL}/contabilidad/reportes`).reply(200, data.contabilidadReportes);

// ============ RRHH ============
mock.onGet(`${API_URL}/rrhh/dashboard`).reply(200, data.rrhhDashboard);
// ============ RRHH ============
mock.onGet(`${API_URL}/rrhh/dashboard`).reply(200, data.rrhhDashboard);
mock.onGet(new RegExp(`${API_URL}/rrhh/empleados.*`)).reply(200, data.rrhhEmpleados);
mock.onPost(`${API_URL}/rrhh/empleados`).reply(201, { message: "Empleado creado" });
mock.onPut(new RegExp(`${API_URL}/rrhh/empleados/\\d+.*`)).reply(200, { message: "Empleado actualizado" });
mock.onGet(new RegExp(`${API_URL}/rrhh/nomina.*`)).reply(200, data.rrhhNomina);
mock.onPost(`${API_URL}/rrhh/nomina`).reply(201, { message: "Nómina generada" });
mock.onGet(new RegExp(`${API_URL}/rrhh/asistencias.*`)).reply(200, data.rrhhAsistencias);
mock.onPost(`${API_URL}/rrhh/asistencias`).reply(201, { message: "Asistencia registrada" });
mock.onGet(new RegExp(`${API_URL}/rrhh/vacaciones.*`)).reply(200, data.rrhhVacaciones);
mock.onPost(`${API_URL}/rrhh/vacaciones`).reply(201, { message: "Vacaciones solicitadas" });
mock.onGet(new RegExp(`${API_URL}/rrhh/evaluaciones.*`)).reply(200, data.rrhhEvaluaciones);
mock.onPost(`${API_URL}/rrhh/evaluaciones`).reply(201, { message: "Evaluación creada" });
mock.onGet(new RegExp(`${API_URL}/rrhh/capacitaciones.*`)).reply(200, data.rrhhCapacitaciones);
mock.onPost(`${API_URL}/rrhh/capacitaciones`).reply(201, { message: "Capacitación registrada" });
mock.onGet(new RegExp(`${API_URL}/rrhh/documentos.*`)).reply(200, data.rrhhDocumentos);
mock.onPost(`${API_URL}/rrhh/documentos`).reply(201, { message: "Documento subido" });

// ============ LOGÍSTICA ============
mock.onGet(`${API_URL}/logistica/dashboard`).reply(200, data.logisticaDashboard);
mock.onGet(`${API_URL}/logistica/rutas`).reply(200, data.logisticaRutas);
mock.onPost(`${API_URL}/logistica/rutas`).reply(201, { message: "Ruta creada" });
mock.onGet(`${API_URL}/logistica/flotas`).reply(200, data.logisticaFlotas);
mock.onPost(`${API_URL}/logistica/flotas`).reply(201, { message: "Vehículo registrado" });
mock.onGet(`${API_URL}/logistica/conductores`).reply(200, data.logisticaConductores);
mock.onPost(`${API_URL}/logistica/conductores`).reply(201, { message: "Conductor registrado" });
mock.onGet(`${API_URL}/logistica/ordenes`).reply(200, data.logisticaOrdenes);
mock.onPost(`${API_URL}/logistica/ordenes`).reply(201, { message: "Orden de envío creada" });
mock.onGet(`${API_URL}/logistica/zonas`).reply(200, data.logisticaZonas);
mock.onPost(`${API_URL}/logistica/zonas`).reply(201, { message: "Zona creada" });
mock.onGet(`${API_URL}/logistica/reportes`).reply(200, data.logisticaReportes);

// ============ REPORTES ============
mock.onGet(new RegExp(`${API_URL}/reportes/dashboard-general.*`)).reply(200, data.reportesDashboardGeneral);
mock.onGet(new RegExp(`${API_URL}/reportes/ventas-operativo.*`)).reply(200, data.reportesVentasOperativo);
mock.onGet(new RegExp(`${API_URL}/reportes/inventario-operativo.*`)).reply(200, data.reportesInventarioOperativo);
mock.onGet(new RegExp(`${API_URL}/reportes/comparativo.*`)).reply(200, data.reportesComparativo);
mock.onGet(new RegExp(`${API_URL}/reportes/indicadores.*`)).reply(200, data.reportesIndicadores);
mock.onGet(new RegExp(`${API_URL}/reportes/financieros.*`)).reply(200, data.reportesFinancieros);
mock.onGet(new RegExp(`${API_URL}/reportes/compras-report.*`)).reply(200, data.reportesCompras);

// ============ CONFIGURACIÓN ============
mock.onGet(`${API_URL}/configuracion`).reply(200, data.configuracion);
mock.onPut(`${API_URL}/configuracion`).reply(200, { message: "Configuración actualizada" });

// ============ CATCH-ALL para cualquier otro endpoint ============
// Esto asegura que si hay endpoints no mapeados, no fallen
mock.onAny().reply((config) => {
    console.warn(`[SADEMS Demo] Endpoint no mapeado: ${config.method?.toUpperCase()} ${config.url}`);
    return [200, { message: "Demo mode - endpoint no configurado", data: [] }];
});

export default mock;
